export const acmgData = {
  criteria_value: [
    {
      supporting: 1,
      moderate: 2,
      strong: 4,
      very_strong: 8,
      standalone: 8,
    },
  ],

  criteria: [
    {
      name: 'PVS1',
      description:
        'Null variant such as nonsense, frameshift, canonical ±1 or 2 splice sites, initiation codon, single or multiexon deletion in a gene where loss of function is a known mechanism of disease.',
      color: '#C70700',
    },
    {
      name: 'PS1',
      description:
        'Same amino acid change as a previously established pathogenic variant, regardless of nucleotide change.',
      color: '#D93115',
    },
    {
      name: 'PS2',
      description:
        'De novo variant in a patient with the disease and no family history, with both maternity and paternity confirmed.',
      color: '#D93115',
    },
    {
      name: 'PS3',
      description:
        'Well-established functional studies show a damaging effect on the gene or gene product.',
      color: '#D93115',
    },
    {
      name: 'PS4',
      description:
        'Variant prevalence in affected individuals is significantly increased compared with controls.',
      color: '#d93115',
    },
    {
      name: 'PM1',
      description:
        'Located in a mutational hot spot or critical functional domain without benign variation.',
      color: '#Eb5b2b',
    },
    {
      name: 'PM2',
      description:
        'Absent from controls or present at extremely low frequency in population databases.',
      color: '#FD8540',
    },
    {
      name: 'PM3',
      description:
        'For recessive disorders, detected in trans with a pathogenic variant.',
      color: '#FD8540',
    },
    {
      name: 'PM4',
      description:
        'Protein length changes caused by in-frame deletions or insertions in a non-repeat region, or stop-loss variants.',
      color: '#Eb5b2b',
    },
    {
      name: 'PM5',
      description:
        'Novel missense change at an amino acid residue where a different missense change has already been established as pathogenic.',
      color: '#Eb5b2b',
    },
    {
      name: 'PM6',
      description:
        'Assumed de novo variant, but without confirmation of maternity and paternity.',
      color: '#Eb5b2b',
    },
    {
      name: 'PP1',
      description:
        'Variant co-segregates with disease in multiple affected family members in a gene known to cause the disease.',
      color: '#fd8540',
    },
    {
      name: 'PP2',
      description:
        'Missense variant in a gene that has a low rate of benign missense variation and where missense variants are a common mechanism of disease.',
      color: '#fd8540',
    },
    {
      name: 'PP3',
      description:
        'Multiple lines of computational evidence support a deleterious effect on the gene or gene product.',
      color: '#fd8540',
    },
    {
      name: 'PP4',
      description:
        'Patient phenotype or family history is highly specific for a disease with a single genetic cause.',
      color: '#fd8540',
    },
    {
      name: 'PP5',
      description:
        'A reputable source reports the variant as pathogenic, but the evidence is not available for independent evaluation.',
      color: '#fd8540',
    },
    {
      name: 'BP1',
      description:
        'Missense variant in a gene where primarily truncating variants are known to cause disease.',
      color: '#73c36f',
    },
    {
      name: 'BP2',
      description:
        'Observed in trans with a pathogenic variant for a fully penetrant dominant gene or disorder, or observed in cis with a pathogenic variant.',
      color: '#73c36f',
    },
    {
      name: 'BP3',
      description:
        'In-frame deletion or insertion in a repetitive region without a known function.',
      color: '#73c36f',
    },
    {
      name: 'BP4',
      description:
        'Multiple lines of computational evidence suggest no impact on the gene or gene product.',
      color: '#73c36f',
    },
    {
      name: 'BP5',
      description:
        'Variant found in a case with an alternate molecular basis for the disease.',
      color: '#73c36f',
    },
    {
      name: 'BP6',
      description:
        'A reputable source reports the variant as benign, but the evidence is not available for independent evaluation.',
      color: '#73c36f',
    },
    {
      name: 'BP7',
      description:
        'Synonymous or non-coding variant where splicing prediction algorithms predict no impact, the nucleotide is not highly conserved, and splicing impact is unlikely.',
      color: '#73c36f',
    },
    {
      name: 'BS1',
      description:
        'Allele frequency is greater than expected for the disorder.',
      color: '#258831',
    },
    {
      name: 'BS2',
      description:
        'Observed in a healthy adult individual for a recessive, dominant, or X-linked disorder where full penetrance is expected at an early age.',
      color: '#258831',
    },
    {
      name: 'BS3',
      description:
        'Well-established functional studies show no damaging effect on the gene or gene product.',
      color: '#258831',
    },
    {
      name: 'BS4',
      description:
        'Lack of segregation with disease in affected members of a family.',
      color: '#258831',
    },
    {
      name: 'BA1',
      description: 'Allele frequency is above 5% in population databases.',
      color: '#076418',
    },
  ],
};
